// Office Phone Line Configuration
// Dropdown options and constants for Office Phone Line popup

export const orderTypeOptions = [
  { value: 'Forborne', label: 'Forborne' },
  { value: 'Non-Forborne / Tariffed', label: 'Non-Forborne / Tariffed' }
];

export const termOptions = [
  { value: '36 Months', label: '36 Months' },
  { value: 'Month to Month', label: 'Month to Month' }
];

export const planOptions = [
  { value: 'Office Phone Basic', label: 'Office Phone Basic' },
  { value: 'Office Phone', label: 'Office Phone' },
  { value: 'Office Phone Plus', label: 'Office Phone Plus' }
];

export const customerTypeOptions = [
  { value: 'New', label: 'New' },
  { value: 'Winback', label: 'Winback' },
  { value: 'Existing Customers', label: 'Existing Customers' }
];

export const lineDesignationOptions = [
  { value: 'Phone', label: 'Phone' },
  { value: 'Fax', label: 'Fax' },
  { value: 'Debit', label: 'Debit' },
  { value: 'Alarm', label: 'Alarm' },
  { value: 'Elevator', label: 'Elevator' }
];

export const lineTypeOptions = [
  { value: 'Single Line', label: 'Single Line' },
  { value: 'Multi Line', label: 'Multi Line' }
];

export const callingFeatureOptions = [
  { value: 'None', label: 'None' },
  { value: 'Call Transfer', label: 'Call Transfer' },
  { value: 'Call Forwarding Busy', label: 'Call Forwarding Busy' },
  { value: 'Call Forwarding Busy / No Answer', label: 'Call Forwarding Busy / No Answer' },
  { value: 'Call Forwarding Fixed', label: 'Call Forwarding Fixed' },
  { value: 'Call Forwarding No Answer', label: 'Call Forwarding No Answer' },
  { value: 'Call Forwarding Variable', label: 'Call Forwarding Variable' },
  { value: 'Call Display', label: 'Call Display' },
  { value: 'Voicemail Enhanced', label: 'Voicemail Enhanced' },
  { value: '3 Way Calling', label: '3 Way Calling' }
];

export const tollFreeOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
];

// All available add-on options
export const allAddOnsOptions = [
  { value: 'CAN / US Calling - 150 minutes', label: 'CAN / US Calling - 150 minutes' },
  { value: 'CAN / US Calling - Unlimited', label: 'CAN / US Calling - Unlimited' },
  { value: '500 International Minutes', label: '500 International Minutes' }
];

// Plan-specific add-on configuration
export const planAddOnsConfig = {
  'Office Phone Basic': {
    available: [
      { value: 'CAN / US Calling - 150 minutes', label: 'CAN / US Calling - 150 minutes', included: false },
      { value: 'CAN / US Calling - Unlimited', label: 'CAN / US Calling - Unlimited', included: false },
      { value: '500 International Minutes', label: '500 International Minutes', included: false }
    ],
    included: [] // No included items for Basic
  },
  'Office Phone': {
    available: [
      { value: 'CAN / US Calling - 150 minutes', label: 'CAN / US Calling - 150 minutes', included: true },
      { value: 'CAN / US Calling - Unlimited', label: 'CAN / US Calling - Unlimited', included: false },
      { value: '500 International Minutes', label: '500 International Minutes', included: false }
    ],
    included: ['CAN / US Calling - 150 minutes']
  },
  'Office Phone Plus': {
    available: [
      { value: 'CAN / US Calling - Unlimited', label: 'CAN / US Calling - Unlimited', included: true },
      { value: '500 International Minutes', label: '500 International Minutes', included: false }
    ],
    included: ['CAN / US Calling - Unlimited']
  }
};

// Form initial values
export const initialFormValues = {
  orderType: '',
  term: '',
  plan: '',
  customPrice: '',
  customerType: '',
  lineDesignation: '',
  lineType: '',
  numberOfLines: '',
  phoneNumbers: '',
  callingFeature1: '',
  callingFeatureUnlimited: [],
  tollFreeNumber: '',
  addOns: []
};

// Form validation rules (if needed in the future)
export const validationRules = {
  numberOfLines: {
    min: 1,
    max: 10
  }
};

// Section styling constants
export const sectionStyles = {
  container: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '5px',
    padding: '15px',
    marginBottom: '20px'
  },
  header: {
    marginBottom: '15px',
    fontWeight: 'bold',
    fontSize: '18px',
    color: '#4b286d'
  }
};
